import React from 'react'
import { useState } from 'react'
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'
export default function Header() {
    const [toggle, setToggle] = useState(false)  //FOR RESPONSIVE MENUE Button
    return (
        <div className='bg-[#3699fb] p-4'>
            <div className=' flex justify-between max-w-[1240px] items-center py-3  border-black mx-auto '>
                <div className=' text-3xl font-bold'> MyWeb</div>
                {
                    toggle ?
                        <AiOutlineClose onClick={() => setToggle(!toggle)} className=' cursor-pointer text-3xl md:hidden block' />
                        : <AiOutlineMenu onClick={() => setToggle(!toggle)} className=' cursor-pointer text-3xl md:hidden block' />
                }
                <ul className='hidden md:flex gap-7 text-white font-bold  ' >
                    <li className=' cursor-pointer'>Home</li>
                    <li className=' cursor-pointer'>Compony</li>
                    <li className=' cursor-pointer'>About</li>
                    <li className=' cursor-pointer'>Contact Us  </li>
                </ul>
                {/* //FOR RESPONSIVE MENUE */}
                <ul className={`duration-500  md:hidden gap-7 text-white h-screen w-full bg-black left-0 top-[92px] font-bold  fixed  ${toggle ? 'left-[0%]' : 'left-[-100%]'}`} >
                    <li className=' cursor-pointer my-7 '>Home</li>
                    <li className=' cursor-pointer my-7 '>Compony</li>
                    <li className=' cursor-pointer my-7 '>About</li>
                    <li className=' cursor-pointer my-7 '>Contact Us  </li>
                </ul>
            </div>
        </div>
    )
}
